import { UsuarioModel } from './../usuario/usuario.model';
export class RamoAtividadeModel {
    id: number;
    descricao: String;
    usuario: UsuarioModel;
}



// WEBPACK FOOTER //
// /app/src/app/model/cliente/ramoatividade.model.ts